import { useLanguage } from "../../context/LanguageContext";
import { welcomeTranslations } from "../../translations/welcomeTranslations";
import { sanitizeHTML } from '../../utils/sanitize';

const LangueTransmissionSection = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = welcomeTranslations;

  return (
    // REDUCED padding by ~20% (py-10 → py-8)
    <section className="py-8 px-6 bg-[#5C4A3D]">
      <div className="max-w-2xl mx-auto text-center space-y-4">
        <h3 className="font-serif text-lg md:text-xl text-[#C5A059] tracking-wide">
          {t(tr.langueTransmission.title)}
        </h3>
        <div className="space-y-3 text-[#F3E5CF] text-sm" style={{ lineHeight: '1.7' }}>
          <p style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.langueTransmission.p1))} />
          {t(tr.langueTransmission.p2) && <p style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.langueTransmission.p2))} />}
          <p className="italic text-[#C5A059]/70 text-xs md:text-sm" style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.langueTransmission.p3))} />
        </div>
      </div>
    </section>
  );
};

export default LangueTransmissionSection;
